// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconHeaderMenuClose: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
            <path d="M17.557429,15.7015914 C18.0844891,16.2272266 18.0844891,17.0800606 17.557429,17.6057524 C17.0303688,18.1314441 16.175223,18.1313876 15.6481062,17.6057524 L9.00091805,10.9271629 L2.3064752,17.6035077 C1.77941421,18.129143 0.924269229,18.129143 0.397152449,17.6035077 C-0.129964332,17.0778725 -0.129908536,16.2250385 0.397152449,15.6993467 L7.09384516,9.02524651 L0.395295739,2.29840864 C-0.131765246,1.77277339 -0.131765246,0.919939381 0.395295739,0.394247627 C0.922356724,-0.131444126 1.77750171,-0.131387625 2.30461849,0.394247627 L9.00091805,7.12333013 L15.6953609,0.446985278 C16.222421,-0.078649974 17.0775669,-0.078649974 17.6046837,0.446985278 C18.1318004,0.972620531 18.1317438,1.82545454 17.6046837,2.35114629 L10.9079901,9.02524651 L17.557429,15.7015914 Z" />
        </svg>
    );
};

export default React.memo(IconHeaderMenuClose);
